import { useEffect, useState, useRef } from 'react';

export const useCooldownTimer = (storageKey: string) => {
  const [timeLeft, setTimeLeft] = useState(0);
  const [isActive, setIsActive] = useState(false);
  const intervalRef = useRef<NodeJS.Timeout | null>(null);

  useEffect(() => {
    const storedEndTime = localStorage.getItem(storageKey);
    if (storedEndTime) {
      const remaining = parseInt(storedEndTime, 10) - Date.now();
      if (remaining > 0) start(remaining);
      else localStorage.removeItem(storageKey);
    }

    return () => {
      if (intervalRef.current) clearInterval(intervalRef.current);
    };
  }, []);

  const start = (durationMs: number) => {
    const endTime = Date.now() + durationMs;
    localStorage.setItem(storageKey, endTime.toString());
    setIsActive(true);
    setTimeLeft(durationMs);

    if (intervalRef.current) clearInterval(intervalRef.current);

    intervalRef.current = setInterval(() => {
      const remaining = endTime - Date.now();
      if (remaining <= 0) {
        clearInterval(intervalRef.current!);
        setTimeLeft(0);
        setIsActive(false);
        localStorage.removeItem(storageKey);
      } else {
        setTimeLeft(remaining);
      }
    }, 1000);
  };

  const reset = () => {
    if (intervalRef.current) clearInterval(intervalRef.current);
    setIsActive(false);
    setTimeLeft(0);
    localStorage.removeItem(storageKey);
  };

  return { timeLeft, isActive, start, reset };
};
